import { Link, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Chip, IconButton, Tab, Tabs, Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useAppSelector } from "redux/hooks";
import { selectUserById } from "redux/slices/client";
import { selectIsSupport } from "redux/slices/session";
import { fullName } from "helpers/name-helpers";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { AppRoutes } from "AppRoutes";

const PatternUser = () => {
  const { userId } = useParamNumbers(["userId"]);
  const user = useAppSelector((state) => selectUserById(state, userId));

  if (user === undefined) {
    return <Navigate to="/users" replace />;
  }

  const isSupportUser = useAppSelector(selectIsSupport);
  const navigate = useNavigate();
  const location = useLocation();
  const tabValue = location.pathname.split("/").pop();

  return (
    <>
      <div className="flex flex-col gap-6 h-full">
        <div>
          <Tooltip title="Back to users">
            <Link to={AppRoutes.patternUsers()}>
              <IconButton size="medium">
                <ArrowBack />
              </IconButton>
            </Link>
          </Tooltip>
        </div>
        <div className="flex items-center gap-4">
          <p className="text-2xl font-bold">{fullName(user)}</p>
          {user !== undefined && user.deactivated && <Chip label="Deactivated" />}
        </div>
        <div className="flex items-center">
          <Tabs value={tabValue}>
            <Tab value="profile" label="Profile" onClick={() => navigate("profile")} />
            <Tab value="lenses" label="Lens Access" onClick={() => navigate("lenses")} />
            {isSupportUser && <Tab value="api" label="API Access" onClick={() => navigate("api")} />}
            <Tab value="advanced" label="Advanced" onClick={() => navigate("advanced")} />
          </Tabs>
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default PatternUser;
